import moment from 'moment';
import {toArray, groupBy} from "lodash-es";
import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'app/services/locale/locale.service';

const NS = 'BookingsOverTimeCtrl';

export default function BookingsOverTimeCtrl(
  $rootScope, $scope, $filter, $timeout, $q,
  bookingsOverTimeReportService
) {
  "ngInject";

  var vm = this;
  //-- define public properties
  const timeZoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate.setMonth(vm.endDate.getMonth() + 1);
  vm.hideDays = true;
  vm.chartConfig = null;
  vm.tableDays = null;
  vm.tableData = null;
  vm.dateDataFormat = 'YYYY-MM-DD';
  vm.dateDisplayFormat = 'DD/MM/YYYY';
  //-- define public methods
  vm.datesChanged = datesChanged;
  vm.lastMonth = lastMonth;
  vm.nextMonth = nextMonth;
  vm.nextWeek = nextWeek;
  vm.nextThreeMonths = nextThreeMonths;
  vm.nextSixMonths = nextSixMonths;
  vm.nextYear = nextYear;
  vm.printReport = printReport;
  vm.exportToCsv = exportToCsv;
  vm.loadResults = loadResults;
  vm.loadError = false;
  vm.loading = false;
  //-- init
  loadResults();

  //-- listen
  $scope.$watch('vm.startDate', datesChanged);
  $scope.$watch('vm.endDate', datesChanged);

  function lastMonth() {
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.startDate.setMonth(vm.startDate.getMonth() - 1);
    datesChanged();
  }

  function nextWeek() {
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate.setDate(vm.endDate.getDate() + 7);
    datesChanged();
  }

  function nextMonth() {
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate.setMonth(vm.endDate.getMonth() + 1);
    datesChanged();
  }

  function nextThreeMonths() {
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate.setMonth(vm.endDate.getMonth() + 3);
    datesChanged();
  }

  function nextSixMonths() {
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate.setMonth(vm.endDate.getMonth() + 6);
    datesChanged();
  }

  function nextYear() {
    vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
    vm.endDate.setMonth(vm.endDate.getMonth() + 12);
    datesChanged();
  }

  /**
   * The dates have changed
   **/
  function datesChanged() {
    if (vm.startDate && vm.endDate && (vm.endDate.getTime() >= vm.startDate.getTime())) {
      loadResults();
    }
  }

  function loadResults() {
    vm.loadError = false;
    vm.loading = true;

    var promises = [
      // EventsService.getEventsBetweenDates(vm.startDate, vm.endDate),
      // bookingsService.getBetweenDates(vm.startDate, vm.endDate),
      bookingsOverTimeReportService.getBookingsByDate(vm.startDate, vm.endDate),
      bookingsOverTimeReportService.getBookingsByService(vm.startDate, vm.endDate)
    ];

    $q.all(promises).then(function (values) {
      buildChart(values[0].data, vm.startDate, vm.endDate);
      buildTablesData(values[1].data, vm.startDate, vm.endDate);
      vm.loading = false;
    }).catch(function (err) {
      console.log(err);
      // data failed to load
      vm.loadError = true;
      vm.loading = false;
    });
  }

  function buildTablesData(data, from, to) {

    // Formatted data
    const results = [];
    const serviceGrouped = toArray(groupBy(data, d => d.serviceType));

    serviceGrouped.forEach(group => {
      const days = {};
      group.forEach(d => {
        days[d.date] = d;
      });
      results.push({
        label: group[0].serviceType,
        days
      });
    });

    // Compute totals
    const totalDays = {};
    const groupedByDay = toArray(groupBy(data, d => d.date));

    groupedByDay.forEach(day => {
      const bookings = day.reduce((tot, v) => tot + v.bookings, 0);
      const covers = day.reduce((tot, v) => tot + v.covers, 0);
      totalDays[day[0].date] = {
        date: day[0].date,
        servuceType: 'Totals',
        bookings: bookings,
        covers: covers,
        total: bookings + covers
      };
    });

    results.push({
      label: 'Totals',
      days: totalDays
    });

    vm.tableDays = getDaysBetween(from, to); // Period days
    vm.tableData = results; // Assign result for UI
  }

  function buildChart(data, from, to) {

    const periodDays = getDaysBetween(from, to);
    const coversData = [];
    const bookingsData = [];

    periodDays.forEach(day => {
      // locale-aware date label for x-axis
      const dateLabel = LocaleService.formatDate(moment(day.key, vm.dateDataFormat).toDate(), 'short');
      const dayData = data.find(d => day.key === d.date) || {bookings: 0, covers: 0};
      coversData.push([dateLabel, dayData.covers]);
      bookingsData.push([dateLabel, dayData.bookings]);
    });

    //This is not a highcharts object. It just looks a little like one!
    const chartConfig = {
      type: 'column',
      //Title configuration (optional)
      title: {
        text: null
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Count'
        },
        // locale-aware number formatting (e.g. fr-CA uses comma as decimal separator)
        labels: {
          formatter: function() {
            return new Intl.NumberFormat(LocaleService.getLocale()).format(this.value);
          }
        }
      },
      //Series object (optional) - a list of series using normal highcharts series options.
      series: [{
        name: 'Covers',
        data: coversData,
        type: 'column',
        color: '#e3e3e3',
      }, {
        name: 'Bookings',
        data: bookingsData,
        type: 'column',
        color: '#A91164',
      }]
    };
    vm.chartConfig = chartConfig;
  }

  function getDaysBetween(from, to) {
    // Period days
    var days = [];
    var current = moment(from);
    var end = moment(to);

    while (!current.isAfter(end)) {
      days.push({
        key: current.format(vm.dateDataFormat),
        label: LocaleService.formatDate(current.toDate(), 'day-month-numeric')
      });
      current = current.add(1, 'days');
    }

    return days;
  }

  function exportToCsv() {

    const reportName = 'StartDate_' + LocaleService.formatDateForFilename(vm.startDate) + '_EndDate_' + LocaleService.formatDateForFilename(vm.endDate);

    const labels = vm.tableDays.map(o => o.label);
    labels.unshift('Service');

    const rows = [];
    vm.tableData.forEach(service => {
      const bookings = [service.label + '_Bookings'];
      const covers = [service.label + '_Covers'];
      vm.tableDays.forEach(d => {
        const day = service.days[d.key] || {bookings: 0, covers: 0};
        bookings.push(day.bookings);
        covers.push(day.covers);
      });
      rows.push(bookings);
      rows.push(covers);
    });

    ConvertJsonToCsv.downloadCsv(rows, labels, reportName);
  }

  // Print button
  function resizeChart() {
    $rootScope.$broadcast('highchartsng.reflow');
  }

  function printReport() {
    vm.printing = true;
    $timeout(function () {
      resizeChart();
      setTimeout(function () {
        window.print();
        printDone();
      }, 200);
    }, 100);
  }

  function printDone() {
    vm.printing = false;
    setTimeout(function () {
      vm.printing = false;
      resizeChart();
    }, 200);
  }
}
